import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Examining the Topology`}</h2>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Click the `}<strong parentName="p">{`Topology`}</strong>{` Tab. `}</p>
      <p parentName="blockquote"><strong parentName="p">{`*Result`}</strong>{`: The topology is displayed.* `}</p>
    </blockquote>
    <img {...{
      "src": "./../images/demo/image.067.png",
      "alt": "image"
    }}></img>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`The interface shows the `}<strong parentName="p">{`topology`}</strong>{` of the application that is relevant to the incident. IBM CloudPak for AIOps’ topology service delivers a working understanding of the resources that you have in your environment, how the resources relate to each other, and how the environment has changed over time.`}</p>
    <p>{`You can see that there are some statuses attached to the different resources, marked with colorful dots. Let’s view the details and status of the `}<strong parentName="p">{`mysql`}</strong>{` resource with red status. `}</p>
    <div style={{
      "pageBreakAfter": "always"
    }}></div>
    <p><img parentName="p" {...{
        "src": "./../images/demo/image.068.png",
        "alt": "image"
      }}></img>{`  `}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Find the resource which displays resource name “`}<strong parentName="p">{`mysql`}</strong>{`”. Then, right-click and select `}<strong parentName="p">{`Resource details.`}</strong>{` `}</p>
      <p parentName="blockquote"><strong parentName="p">{`*Result`}</strong>{`: Detailed view displays.*`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Click on Tab `}<strong parentName="p">{`Alerts`}</strong>{` `}</p>
      <p parentName="blockquote"><strong parentName="p">{`*Result`}</strong>{`: Detailed view of the Alerts specific for this resource.*`}</p>
    </blockquote>
    <img {...{
      "src": "./../images/demo/image.069.png",
      "alt": "image"
    }}></img>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong>{` `}</p>
    <p>{`The topology service provides operations teams with complete up-to-date visibility over dynamic infrastructure, resources, and services. The topology service lets you query a specific resource for details, and other relevant information. Here I can see all Alerts for the mysql database resource for example.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      